// extracted by mini-css-extract-plugin
export var active = "overlay-module--active--f6-Z9";
export var overlay = "overlay-module--overlay--2ga1Q";